import { makeStyles, createStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    radioGroup: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      justifyContent: "flex_start",
    },
    radio: {
      width: "30%",
      paddingRight: theme.spacing(1),
    },
  })
)

export default useStyles
